<template>
	<cards-view :fanzoneTypesIds='[4]' url='fanzone-roadtour' />
</template>

<script>
	import cardsView from '../components/CardsView'
	
	export default {
		components: { cardsView }
	}
</script>
